import "./ChangePinCodeModal.scss"
import { FC, useState } from "react"
import { Button, FormHelperText, Typography } from "@mui/material"
import PinInput from "../../PinInput/PinInput.component"
import GenericModal from "../GenericAppModal/GenericModal.component"
import useFormValidation from "../../../hooks/useFormValidation"
import { useTranslationLabel } from "../../../hooks/useTranslationLabel"
import { useAppDispatch, useAppSelector } from "../../../redux/hooks"
import { useValidationSchemas } from "../../../hooks/useIsValidationScehemes"
import { getUserAsync, updateUserAsync, selectUserData } from "../../../redux/slices/authSlice"
import { UserData } from "../../../types/userTypes"
type ChangePinCodeModalProps = {
  open: boolean
  handleClose: () => void
}

const ChangePinCodeModal: FC<ChangePinCodeModalProps> = ({
  open,
  handleClose,
}) => {
  const {
    CHANGE_PINCODE_MODAL_TITLE,
    INPUT_CURRENT_PINCODE,
    INPUT_NEW_PINCODE,
    INPUT_CONFIRM_NEW_PINCODE,
    BTN_CONFIRM,
    BTN_CANCEL,
    WRONG_PINCODE,
  } = useTranslationLabel()
  const dispatch = useAppDispatch()
  const [loading, setLoading] = useState(false)
  const { changePinCodeSchema } = useValidationSchemas()
  const userData: UserData | null = useAppSelector(selectUserData)

  const userCurrentPin = userData?.drivingSettings?.pincode || ""

  const { formData, errors, handleChange, validateField, validateForm } =
    useFormValidation(
      {
        currentPin: "",
        newPin: "",
        confirmNewPin: "",
      },
      changePinCodeSchema,
    )

  const handlePinChange = (pin: string, field: any) => {
    handleChange({ target: { name: field, value: pin } } as any) // TODO LOW: fix any
    validateField(field, pin)
  }

  const handleSubmit = async () => {
    if (validateForm()) {
      // setLoading(true)
      const reqData = {
        oldPincode: formData.currentPin,
        newPincode: formData.newPin,
      }

      if (validateForm()) {
        setLoading(true)
        await dispatch(updateUserAsync(formData))
          .unwrap()
          .then(() => { })
          .catch((err) => {
            alert("Something went wrong!")
          })
          .finally(() => {
            formData.currentPin = "";
            formData.newPin = "";
            formData.confirmNewPin = "";
            handleClose()
            dispatch(getUserAsync())
            setLoading(false)
          })
      }

    }
  }

  return (
    <GenericModal
      open={open}
      handleClose={handleClose}
      title={CHANGE_PINCODE_MODAL_TITLE}
      className="change-pin-code"
      loading={loading}
    >
      <div className="pincode-container">
        <Typography className="body1">{INPUT_CURRENT_PINCODE}</Typography>
        <PinInput
          value={formData.currentPin}
          onPinChange={(value) => handlePinChange(value, "currentPin")}
          shouldFocus={true}
          error={formData.currentPin.length === 4 && userCurrentPin !== formData.currentPin}
          helperText={WRONG_PINCODE}
        />
        {errors.currentPin && (
          <Typography color="error" className="error-message">
            {errors.currentPin}
          </Typography>
        )}
      </div>

      <div className="pincode-container">
        <Typography className="body1">{INPUT_NEW_PINCODE}</Typography>
        <PinInput
          value={formData.newPin}
          onPinChange={(value) => handlePinChange(value, "newPin")}
          shouldFocus={false}
        />

        {errors.newPin && (
          <FormHelperText error>{errors.newPin}</FormHelperText>
        )}
      </div>

      <div className="pincode-container">
        <Typography className="body1">{INPUT_CONFIRM_NEW_PINCODE}</Typography>
        <PinInput
          value={formData.confirmNewPin}
          onPinChange={(value) => handlePinChange(value, "confirmNewPin")}
          shouldFocus={false}
        />
        {errors.confirmNewPin && (
           <FormHelperText error>{errors.confirmNewPin}</FormHelperText>
        )}
      </div>

      <div className="action-buttons">
        <Button
          disabled={formData.currentPin.length !== 4 && userCurrentPin !== formData.currentPin} 
          className="primary-btn"
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleSubmit}
        >
          {BTN_CONFIRM}
        </Button>
        <Button
          className="primary-btn secondary"
          variant="outlined"
          fullWidth
          onClick={handleClose}
        >
          {BTN_CANCEL}
        </Button>
      </div>
    </GenericModal>
  )
}

export default ChangePinCodeModal
